module.exports = __webpack_public_path__ + "img/pic1.990a9536.png";